import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CrossComponentCommunicationService {

  toHeader = new BehaviorSubject<boolean>(false);
  toFooter = new BehaviorSubject<boolean>(false);

  toSteps = new BehaviorSubject<boolean>(false);
}
